import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useConfig } from "../../../../../app/configcontext";
import { useDispatch, useSelector } from "react-redux";
import { businessSlice } from "../../../../../features/business/businessSlice";
import ProtectedPaymentRoute from "../../../../auth/Auth";

export default function BusinessStart() {
  ProtectedPaymentRoute();

  const { id } = useParams();
  const navigate = useNavigate();
  const actions = businessSlice.actions;
  const dispatch = useDispatch();
  const business = useSelector((state) => state.business);
  const config = useConfig();
  const questionnaires = useSelector((state) => state.business.questionnaire) || [];
  const question = config?.questions?.find((item) => Number(item.questionId) === Number(id));
  const options = config?.options?.filter((item) => Number(item.questionId) === Number(id)) || [];
  const savedQuestion = questionnaires.find((item) => item.questionId === +id);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [errors, setErrors] = useState({});
  const selectedType = useSelector((state) => state.corpo)?.selectedType;

  let totalQuestions = selectedType === "S-Corp" ? 6 : 5;

  useEffect(() => {
    if (savedQuestion) {
      setSelectedOptions((prev) => ({ ...prev, [id]: savedQuestion.answerId }));
    }
  }, [id, savedQuestion]);

  const handleOptionChange = (optionId) => {
    setSelectedOptions({ ...selectedOptions, [id]: optionId });
    setErrors({ ...errors, [id]: "" });
  };

  const handleNextButtonClick = (e) => {
    if (e) e.preventDefault();
    if (!selectedOptions[id]) {
      setErrors({ ...errors, [id]: "Please select an option before proceeding." });
      return;
    }

    const answerId = +selectedOptions[id] || 0;
    dispatch(actions.update_question({ questionId: +id, answerId }));

    switch (+id) {
      case 1:
        navigate("/business_type");
        break;
      case 2:
        navigate("/corp_question/3");
        break;
      case 3:
        navigate("/corp_question/4");
        break;
      case 4:
        navigate("/corp_question/5");
        break;
      case 5:
        navigate("/compliant");
        break;
      case 6:
        navigate("/bank_details");
        break;
      default:
        navigate(-1);
    }
  };

  const handleNextPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleNextButtonClick(e);
    }
  };

  const backbtn = (questionId) => {
    switch (questionId) {
      case 1:
        navigate("/contact_details");
        break;
      case 2:
        navigate("/member_corpo");
        break;
      case 3:
        navigate("/corp_question/2");
        break;
      case 4:
        navigate("/corp_question/3");
        break;
      case 5:
        navigate("/corp_question/4");
        break;
      case 6:
        navigate("/corp_question/5");
        break;
      default:
        navigate("/corp_question/4");
        break;
    }
  };

  return (
    <div className="min-h-[75vh] bg-white py-12 lg:py-20 font-sans">
      {question && (
        <div className="container mx-auto px-4 lg:px-8 max-w-3xl">
          
          {/* Progress Indicator */}
          <div className="mb-8">
            <span className="text-[#1a73e8] font-medium tracking-wider uppercase text-xs mb-2 block">
              Question {id} of {totalQuestions}
            </span>
            <div className="w-full bg-[#e8eaed] h-1.5 rounded-full overflow-hidden">
              <div
                className="bg-[#1a73e8] h-full transition-all duration-300 rounded-full"
                style={{ width: `${(+id / totalQuestions) * 100}%` }}
              ></div>
            </div>
          </div>

          {/* Heading */}
          <div className="mb-8">
            <h1 className="text-2xl sm:text-3xl font-normal text-[#202124] tracking-tight mb-3">
              {question.question.replace(
                "{company name}",
                business?.businessDetails?.businessName || "your company"
              )}
            </h1>
            {question.questionId === 4 && (
              <p className="text-[14.5px] text-[#5f6368] leading-relaxed">
                Professional corporations are statutory entities formed specifically for licensed professionals such as medicine, law, accounting, and architecture.
              </p>
            )}
          </div>

          {/* Options Grid */}
          <form onKeyDown={handleNextPress} className="space-y-3.5 mb-8">
            {options.map((ele) => {
              const isSelected = selectedOptions[id] === ele.optionId || selectedOptions[id] === String(ele.optionId);
              return (
                <div
                  key={ele.optionId}
                  onClick={() => handleOptionChange(ele.optionId)}
                  className={`p-5 rounded-[12px] border-2 cursor-pointer transition-all flex items-center justify-between ${
                    isSelected
                      ? "border-[#1a73e8] bg-[#f8fafd] shadow-sm"
                      : "border-[#dadce0] bg-white hover:border-[#bdc1c6]"
                  }`}
                >
                  <div className="flex items-center gap-3.5">
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all shrink-0 ${
                      isSelected ? "border-[#1a73e8] bg-transparent" : "border-[#747775] bg-white"
                    }`}>
                      {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-[#1a73e8]"></div>}
                    </div>
                    <span className="text-[15.5px] font-medium text-[#202124]">{ele.option}</span>
                  </div>
                </div>
              );
            })}
          </form>

          {errors[id] && (
            <p className="text-[#d93025] text-[13.5px] mb-6 flex items-center gap-1.5 font-medium">
              <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd"></path></svg>
              {errors[id]}
            </p>
          )}

          {/* Actions */}
          <div className="flex items-center justify-between pt-6 border-t border-[#f1f3f4]">
            <button
              type="button"
              onClick={() => backbtn(question.questionId)}
              className="px-6 py-2.5 rounded-[4px] border border-[#dadce0] text-[#1a73e8] font-medium hover:bg-[#f8f9fa] transition-colors flex items-center gap-2 cursor-pointer text-[14px]"
            >
              <i className="fa-solid fa-arrow-left text-xs"></i> Back
            </button>
            <button
              type="button"
              onClick={handleNextButtonClick}
              className="px-8 py-2.5 rounded-[4px] bg-[#1a73e8] hover:bg-[#1557b0] !text-white font-medium shadow-sm transition-all flex items-center gap-2 cursor-pointer text-[14px]"
            >
              Next <i className="fa-solid fa-arrow-right text-xs"></i>
            </button>
          </div>

        </div>
      )}
    </div>
  );
}
